import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { Component } from "react";
import toast from "react-hot-toast";
import { callAPI } from "../../../utils/API";
import { generateModalStyle } from "../../../utils/Misc";
import { TextField } from "@mui/material";

interface EditOverheadRatesModalProps {
  open: boolean;
  onClose: () => void;
}

interface EditOverheadRatesModalState {
  rates: OverheadRate[];
}

interface OverheadRate {
  name: string;
  rate: number;
}

class EditOverheadRatesModal extends Component<
  EditOverheadRatesModalProps,
  EditOverheadRatesModalState
> {
  constructor(props: EditOverheadRatesModalProps) {
    super(props);
    this.state = {
      rates: []
    };
  }

  componentDidMount() {
    this.getOverheadRates();
  }

  getOverheadRates() {
    callAPI("tables/overhead_rates")
      .then((res) => {
        this.setState({
          rates: res
        });
      })
      .catch((err) => {
        toast.error("Error getting labor rates.");
      });
  }

  saveOverheadRates() {
    callAPI("actions/settings", "POST", {
      action: "set_rates",
      kind: "overhead_rates",
      rates: this.state.rates
    })
      .then((res) => {
        this.getOverheadRates();
        this.props.onClose();
      })
      .catch((err) => {
        toast.error("Error updating overhead rates.");
      });
  }

  render() {
    return (
      <div>
        <Modal
          open={this.props.open}
          onClose={this.props.onClose}
          aria-labelledby="selectProductModalLabel"
        >
          <Box sx={generateModalStyle("78%")}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Edit Overhead Rates
            </Typography>
            <div className="row row-cols-2">
              {this.state.rates.map((rate) => {
                return (
                  <div className="col" key={rate.name}>
                    <TextField
                      label={rate.name}
                      type="number"
                      fullWidth
                      value={rate.rate}
                      onChange={(e) => {
                        const newRates = this.state.rates.map((r) => {
                          if (r.name === rate.name) {
                            return { ...r, rate: Number(e.target.value) };
                          }
                          return r;
                        });
                        this.setState({ rates: newRates });
                      }}
                    />
                  </div>
                );
              })}
            </div>
            <div className="d-flex w-100 gap-2 justify-content-end mt-2">
              <button
                onClick={() => {
                  this.saveOverheadRates();
                }}
                className="btn btn-primary"
              >
                Save
              </button>
            </div>
          </Box>
        </Modal>
      </div>
    );
  }
}

export default EditOverheadRatesModal;
